export default class Cloud extends Phaser.Group {
  constructor(game, x, y, size) {
    super(game);
    this.x = x;
    this.y = y;

    this.asset = this.game.make.spine(0, 0, 'spine_cloud', true);
    this.asset.anchor.set(0.5, 1);
    this.rootBone = this.asset.skeleton.getRootBone();
    this.rootBone.scaleX = size;
    this.rootBone.scaleY = size;

    this.addChild(this.asset);

    this.asset.setAnimationByName(0, 'animation', false);
    this.asset.onComplete.addOnce(this.handleAnimComplete, this);
  }

  get depth() {
    return this.y + 400;
  }

  handleAnimComplete() {
    this.destroy();
  }
}
